import React from "react";
import { hospitalPhotos } from "../hospitalPhotos";
import "./HospitalGallery.css";

const HospitalGallery = () => {
  return (
    <section className="hospital-gallery" id="hospital-gallery">
      <div className="hospital-gallery__container">
        <div className="hospital-gallery__intro">
          <h2>Our Hospital in Pictures</h2>
          <p>Explore our hospital, care team and operating theatres.</p>
        </div>

        <div className="hospital-gallery__grid">
          {hospitalPhotos.map(({ id, img, alt, caption, width, height }) => (
            <figure className="hospital-gallery__card" key={id}>
              <a
                className="hospital-gallery__link"
                href={img}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${alt}. Open full-size image in a new tab.`}
              >
                <span className="hospital-gallery__image-frame">
                  <img
                    src={img}
                    alt={alt}
                    loading="lazy"
                    decoding="async"
                    width={width}
                    height={height}
                  />
                </span>
              </a>
              <figcaption>{caption}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HospitalGallery;
